<template>
  <div class="academicas">
    <p class="titleColorSystem text-center">instituciones académicas</p>
    <div class="sci-aca-texto">
      En el presente apartado, se puede ver un listado de las distintas
      instituciones académicas que se encuentran registradas, a las cuales se le
      puede hacer una búsqueda por medio del nombre de la institucion o las
      siglas de la misma.
    </div>
    <div class="sci-aca-content">
      <table class="sci-aca-table">
        <thead class="sci-aca-thead">
          <div class="sci-aca-busqueda">
            <input
              v-model="search"
              type="text"
              placeholder="Buscar Institución"
              @click="limpiarCampos"
              autofocus
            /><button class="sci-aca-lupa"></button>
          </div>
          <span class="sci-aca-count"
            >Hay {{ acaCount }} instituciones que coinciden con el filtro<br><vue-excel-xlsx
              class="sci-aca-excel"
              :data="academicaExcel.data"
              :columns="columns"
              :filename="'Instituciones academicas'"
              :sheetname="'academicas1'"
            >
              Descargar datos excel
            </vue-excel-xlsx></span>
            
          <tr class="sci-aca-tr1">
            <td>nombre</td>
            <td>siglas</td>
            <td>municipio</td>
            <td>domicilio</td>
            <td>página web</td>
          </tr>
        </thead>
        <tbody class="sci-aca-tbody">
          <tr
            class="sci-aca-tr2"
            v-for="academica in nuevasAcademicas.data"
            :key="academica.id"
          >
            <td>{{ academica.nombre }}</td>
            <td>{{ academica.siglas }}</td>
            <td>{{ academica.municipio }}</td>
            <td>{{ academica.domicilio }}</td>
            <a
              class="sci-aca-anchor"
              target="blank"
              :href="academica.pagina_web"
              :title="academica.pagina_web"
            >
              <td>{{ academica.pagina_web ? academica.pagina_web : "" }}</td>
            </a>
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination
            :limit="vPaginator.limit"
            :data="nuevasAcademicas"
            @pagination-change-page="listarNuevasAcademicas"
          ></pagination>
        </div>
        <v-spacer></v-spacer>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueExcelXlsx from "vue-excel-xlsx";
export default {
  props: ["urlApi"],
  name: "academicas",
  data() {
    return {
      search: null,
      columns: [
        {label: "Institución", field: "nombre"},
        {label: "Siglas", field: "siglas"},
        {label: "Municipio", field: "municipio"},
        {label: "Domicilio", field: "domicilio"},
        {label: "Pagina web", field: "pagina_web"},
      ],
      nuevasAcademicas: {
        current_page: 1,
        data: [],
      },
      academicaExcel: {},
      vPaginator: {
        limit: 10,
      },
      selected: 4,
      CurrentElement: {},
    };
  },
  watch: {
    search: function(value) {
      this.listarNuevasAcademicas();
      this.getAcademicas();
    },
  },
  methods: {
    listarNuevasAcademicas: function(page = 1) {
      var url= process.env.VUE_APP_API_URL + `/api/academica?page=${page}&query=${this.search}`;
      axios
        .get(url)
        .then((response) => { this.nuevasAcademicas = response.data; })
        .catch((error) => errorHandling(error));
    },
    getAcademicas: function() {
      var url= process.env.VUE_APP_API_URL + `/api/academica?query=${this.search}&perPage=200&page=1`;
      axios
        .get(url)
        .then((response) => { this.academicaExcel = response.data; })
        .catch((error) => errorHandling(error));
    },
    limpiarCampos() {
      this.search = "";
      this.CurrentElement.nombre = "";
      this.CurrentElement.siglas = "";
      this.CurrentElement.municipio = "";
      this.CurrentElement.domicilio = "";
      this.CurrentElement.nombre_titular = "";
      this.CurrentElement.ap_pat_titular = "";
      this.CurrentElement.ap_mat_titular = "";
      this.CurrentElement.nombre_res_inv = "";
      this.CurrentElement.ap_pat_res_inv = "";
      this.CurrentElement.ap_mat_res_inv = "";
      this.CurrentElement.pagina_web = "";
      this.CurrentElement.correo_titular = "";
      this.CurrentElement.correo_res_inv = "";
    },
  },
  created() {
    this.listarNuevasAcademicas();
    this.limpiarCampos();
    this.getAcademicas();
  },
  computed: {
    acaCount() {
      return this.nuevasAcademicas.total;
    },
  },
};
</script>

<style>
.sci-aca-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-aca-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-aca-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-aca-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-aca-texto {
  width: 50%;
  margin: 1% auto;
  line-height: 1.5;
}
.sci-aca-content {
  display: grid;
  grid-template-areas: "sci-aca-table sci-aca-show";
  grid-template-columns: 1fr;
  margin: 0 0 4% 0;
}
.sci-aca-table {
  display: grid;
  grid-area: sci-aca-table;
  border-spacing: 0;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
  align-content: start;
  margin-bottom: 200px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-aca-thead {
  background: transparent;
  color: #fff;
  padding: 15px;
}
.sci-aca-busqueda {
  color: black;
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 1fr;
  position: relative;
}
.sci-aca-busqueda input {
  background: #fff;
  width: 40%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: 0.8em;
  position: relative;
  background: gainsboro;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-aca-busqueda input:focus {
  outline: 0;
}
.sci-aca-busqueda input::placeholder {
  text-transform: uppercase;
}
.sci-aca-lupa {
  background: #0084ff;
  border: none;
  width: 35px;
  height: 32px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 0;
  left: 37%;
}
.sci-aca-lupa:before {
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-aca-lupa:after {
  content: "";
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-aca-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-aca-excel{
  text-align: left;
  /* color: black; */
  font-size: 1.1rem;
  font-weight: bold;
}
.sci-aca-tr1 {
  display: grid;
  grid-template-columns: 28% 15% 15% 20% 22%;
  text-transform: uppercase;
  text-align: left;
  font-weight: 100;
  color: #000;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-aca-tbody {
  text-align: left;
}
.sci-aca-tr2 {
  display: grid;
  grid-template-columns: 28% 15% 15% 20% 26%;
  padding: 10px;
  text-transform: uppercase;
}
.sci-aca-tr2 td {
  padding: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.sci-aca-anchor {
  text-overflow: ellipsis;
  display: flex;
  max-width: 210px;
}
.sci-aca-show {
  margin-top: 50px;
  display: grid;
  grid-area: sci-aca-show;
  background: rgba(245, 245, 245, 1) !important;
  border-radius: 0px 10px 0px 10px;
  -webkit-border-radius: 0px 10px 0px 10px;
}
.sci-aca-nameAca {
  text-align: left;
  width: 90%;
  max-height: 100px;
  margin: 2% 4%;
  color: rgba(0, 132, 255, 1);
  font-size: 1.7em;
}
.sci-aca-cont-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-aca-info1 {
  display: grid;
  width: 80%;
  margin: 0 auto;
}
.sci-aca-info1 div,
.sci-aca-info2 div {
  padding: 15px 0;
  color: #000;
}
.sci-aca-info1-p1,
.sci-aca-info1-p2,
.sci-aca-info1-p3,
.sci-aca-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
.sci-aca-info2 {
  display: grid;
  color: #000;
}
.sci-aca-info2-p1,
.sci-aca-info2-p2,
.sci-aca-info2-p3,
.sci-aca-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}

@media only screen and (max-width: 850px) and (min-width: 100px) {
  .sci-aca-content {
    grid-template-areas: "sci-aca-table";
    grid-template-columns: 1fr;
  }
  .sci-aca-table {
    width: 90%;
    margin: 2% auto;
    margin-bottom: 100px;
  }
  .sci-aca-show {
    width: 90%;
    grid-area: auto;
    margin: 0 auto;
  }
}
.text-center{
  text-align: center;
}
</style>
